import { Component, Input, ViewChild, signal } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Menu } from "primeng/menu";
import { PrimeNgModule } from "@primeng";

export interface AsyncMenuItem extends MenuItem {
    id?: string;
    asyncAction?: (event: Event) => Promise<void>;
    loading?: () => boolean;
}

@Component({
    selector: "async-menu",
    standalone: true,
    imports: [
        PrimeNgModule
    ],
    template: `
        <p-menu
            #menu
            [popup]="true"
            [model]="menuItems"
            [appendTo]="appendTo">
            <ng-template pTemplate="item" let-item>
                <div class="p-menuitem-content" data-pc-section="content">
                    <a
                        *ngIf="item.asyncAction"
                        pRipple
                        class="p-ripple p-element p-menuitem-link"
                        [ngClass]="{'p-disabled': item.disabled || (item.loading && item.loading())}"
                        (click)="handleAsyncAction(item, $event)"
                        tabindex="-1"
                        data-pc-section="action">
                        <span
                            [class]="'p-menuitem-icon ' + (item.loading && item.loading() ? loadingIcon : item.icon)"
                            *ngIf="item.icon || (item.loading && item.loading())"></span>
                        <span class="p-menuitem-text">{{ item.label }}</span>
                    </a>
                    <a
                        *ngIf="!item.asyncAction"
                        pRipple
                        class="p-ripple p-element p-menuitem-link"
                        [ngClass]="{'p-disabled': item.disabled}"
                        (click)="item.command && item.command($event); menu.hide()"
                        tabindex="-1"
                        data-pc-section="action">
                        <span [class]="'p-menuitem-icon ' + item.icon" *ngIf="item.icon"></span>
                        <span class="p-menuitem-text">{{ item.label }}</span>
                    </a>
                </div>
            </ng-template>
        </p-menu>
    `
})
export class AsyncMenuComponent {
    @ViewChild("menu") menu: Menu;

    @Input() menuItems: AsyncMenuItem[] = [];
    @Input() appendTo: string = "body";
    @Input() loadingIcon: string = "pi pi-spin pi-spinner";

    async handleAsyncAction(item: AsyncMenuItem, event: Event) {
        event.stopPropagation();
        event.preventDefault();

        if (item.disabled || (item.loading && item.loading())) {
            return;
        }

        await item.asyncAction(event);
        this.menu?.hide();
    }

    toggle(event: Event) {
        this.menu?.toggle(event);
    }

    hide() {
        this.menu?.hide();
    }
}